const selectAmendmentResourceOriginOptions = [
  {
    id: 1,
    name: 'Governo Federal',
    productSystems: [3],
  },
  {
    id: 2,
    name: 'Governo Estadual',
    productSystems: [3],
  },
  {
    id: 3,
    name: 'Pedido de outro parlamentar',
    productSystems: [3],
  },
  {
    id: 4,
    name: 'Solicitação para Deputado Estadual, Federal',
    productSystems: [1, 2],
  },
];

export default selectAmendmentResourceOriginOptions;
